import SoundOn from './SoundOn.js';

export {
    SoundOn,
}; 